import { MatDialog } from '@angular/material/dialog';
import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ContactConfirmationModalComponent } from '../contact-confirmation-modal/contact-confirmation-modal.component';
import { ContactUsService } from '@core/services/contact.service';
import { GlobalService } from '@core/services';
import { Loader } from '@googlemaps/js-api-loader';

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.scss'],
})
export class ContactUsComponent implements OnInit {


  contactConfirmationDialogRef: MatDialogRef<ContactConfirmationModalComponent> | undefined;;
  name = "";
  email = "";
  message = "";
  isEnabld = false;
  facebookLink = "";
  instaLink = "";
  youTubeLink = "";
  twitterLink = "";
  linkedInLink = "";
  lang='';
  constructor(
    private dialogService: MatDialog,
    private contactService: ContactUsService,
    private globalService: GlobalService,
  ) { }

  ngOnInit(): void {
    
    this.lang = localStorage.getItem('language') || 'en';
    this.getMap();

    this.facebookLink = "https://www.facebook.com/RoboGardenInc/";
    this.twitterLink = "https://twitter.com/RoboGardenInc";
    this.instaLink = "https://www.instagram.com/robogardeninc/";
    this.linkedInLink = "https://www.linkedin.com/company/robogarden-inc/";
    this.youTubeLink = "https://www.youtube.com/channel/UCHIqV0a1Nex3vX43V7qnF4w";
  }

  getMap() {
    let loader = new Loader({
      apiKey: 'AIzaSyC5HDPFniqhn79NbOcpTdbuALHGdqf0GRo',
    });

    loader.load().then(() => {
      new google.maps.Map(document.getElementById("map")!, {
        center: { lat: 51.049999, lng: -114.066666 },
        zoom: 5,
      })
    });

  }
  onSubmit() {
    this.isEnabld = true;
    const body = {
      name: this.name,
      email: this.email,
      message: this.message
    };

    this.contactService.confirmContact(body).subscribe(res => {
      if (res.status_code === 200) {
        this.globalService.showTranslatedToast('success', res.Object, 'success', 10000);
        this.contactConfirmationDialogRef = this.dialogService.open(ContactConfirmationModalComponent);
        this.isEnabld = false;
      }
    }, err => {
      this.isEnabld = false;
    });

  }

}
